import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select'
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import Popup from '../../components/popup/Popup';
import { useNavigate, useParams } from 'react-router-dom';
import baseUrl, { corporateUrl } from '../../config/config';
import '../../styles/assetModify/assetModify.css'; // Import the CSS file
import '../../styles/form/form.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faUserCheck, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import api from '../../api/api';
import { IoMdRefresh } from "react-icons/io";
import icons from '../../data/assetTypes';
import { Tooltip } from 'react-tooltip';
import { HiOutlineArrowSmLeft } from 'react-icons/hi';
import { BsTrash, BsCheckCircleFill, BsCircle } from 'react-icons/bs';

const Update = ({ setActiveIndex }) => {

  const { id, objId } = useParams();
  const [options, setOptions] = useState([])
  const selectRef = useRef()
  const [initialAllocated, setInitiallyAllocated] = useState('');
  const event = 'Edited';
  const [instock, setIsInstock] = useState(false);
  const [details, setDetails] = useState(null);
  const token = localStorage.getItem('token'); //retrive the token from the local storage
  const emp_id = localStorage.getItem('user_id');
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    assetNumId: '',
    assetNumber: '',
    employeeId: Number(emp_id),
    assetType: '',
    assetTypeId: '',
    assetCategory: '',
    status: '',
    allocatedPerson: '',
    allocatedPersonId: '',
    seat_allocation: '',
    role: '',
    yearOfPurchase: '',
    remarks: '',
    parentAsset: '',
    purpose: '',
    fields: [],
    attachments: [],
  });
  const [updatedFormData, setUpdatedFormData] = useState({

  });
  const [activityData, setActivityData] = useState({
    assetNumber: '',
    employeeId: Number(emp_id),
    event: event,
    updatedFields: '',
  });
  const [popup, setPopup] = useState(null);
  const [allEmployees, setAllEmployees] = useState([])
  const [optionsData, setOptionsData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [attachmentType, setAttachmentType] = useState('');
  const [attachmentName, setAttachmentName] = useState('');
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [existingAttachments, setExistingAttachments] = useState([]);
  const [deletedExistingIndices, setDeletedExistingIndices] = useState([]);
  const [deletedNewIndices, setDeletedNewIndices] = useState([]);
  const [existingActiveStatus, setExistingActiveStatus] = useState({});
  const [newActiveStatus, setNewActiveStatus] = useState({});
  const [documentTypes, setDocumentTypes] = useState([]);
  const [newDocTypeName, setNewDocTypeName] = useState('');
  const [showNewDocTypeInput, setShowNewDocTypeInput] = useState(false);
  const [isDocTypeDropdownOpen, setIsDocTypeDropdownOpen] = useState(false);
  const docTypeDropdownRef = React.useRef(null);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        if (!token) {
          navigate("/login")
        } else {
          const response = await api.get(`${baseUrl}/api/asset-detail/${objId}`, {
            headers: {
              'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
            },
          });
          const assetDetailsResponse = response.data[0];
          //setDetails(assetDetailsResponse);
          setDetails({
            assetNumId: assetDetailsResponse?.assetDetails?.assetNumId || '',
            assetNumber: assetDetailsResponse?.assetDetails?.assetNumber || '',
            assetType: assetDetailsResponse?.assetType?.assetType || '',
            assetTypeId: assetDetailsResponse?.assetType?.assetTypeId || '',
            assetCategory: assetDetailsResponse?.assetType?.assetCategory || '',
            status: assetDetailsResponse?.assetDetails?.status || '',
            allocatedPerson: assetDetailsResponse?.allocatedPersonDetails?.first_name || '',
            allocatedPersonId: Number(assetDetailsResponse?.allocatedPersonDetails?.employeeId) || '',
            seat_allocation: assetDetailsResponse?.allocatedPersonDetails?.seat_allocation || '',
            role: (assetDetailsResponse?.other_roleDetails?.roleName ? assetDetailsResponse?.other_roleDetails?.roleName : assetDetailsResponse?.roleDetails?.roleName) || '',
            yearOfPurchase: assetDetailsResponse?.assetDetails?.yearOfPurchase || '',
            remarks: assetDetailsResponse?.assetDetails?.remarks || '',
            parentAsset: assetDetailsResponse?.assetDetails?.parentAsset || '',
            purpose: assetDetailsResponse?.assetDetails?.purpose || '',
            fields: assetDetailsResponse?.fieldDetails?.map(field => {
              const spec = assetDetailsResponse.specifications.find(spec => spec.feildId === field.feildId || spec.fieldId === field.feildId) || {};
              return {
                fieldId: field.feildId || '', // Ensure fieldId is properly referenced
                fieldName: field.fieldName || '', // Ensure fieldName is properly referenced
                fieldValId: spec.fieldValId || '',
                fieldData: spec.fieldValue || ' ',
                fieldType: field.fieldType || '',
                options: field.options || [],// Assume options is an array of dropdown options
                mandatory: field.mandatory || ''
              };
            }) || [],
            attachments: [],
          });
          setFormData({
            assetNumId: assetDetailsResponse?.assetDetails?.assetNumId || '',
            assetNumber: assetDetailsResponse?.assetDetails?.assetNumber || '',
            assetType: assetDetailsResponse?.assetType?.assetType || '',
            assetTypeId: assetDetailsResponse?.assetType?.assetTypeId || '',
            assetCategory: assetDetailsResponse?.assetType?.assetCategory || '',
            status: assetDetailsResponse?.assetDetails?.status || '',
            allocatedPerson: assetDetailsResponse?.allocatedPersonDetails?.first_name || '',
            allocatedPersonId: Number(assetDetailsResponse?.allocatedPersonDetails?.employeeId) || '',
            seat_allocation: assetDetailsResponse?.allocatedPersonDetails?.seat_allocation || '',
            role: (assetDetailsResponse?.other_roleDetails?.roleName ? assetDetailsResponse?.other_roleDetails?.roleName : assetDetailsResponse?.roleDetails?.roleName) || '',
            yearOfPurchase: assetDetailsResponse?.assetDetails?.yearOfPurchase || '',
            remarks: assetDetailsResponse?.assetDetails?.remarks || '',
            parentAsset: assetDetailsResponse?.assetDetails?.parentAsset || '',
            purpose: assetDetailsResponse?.assetDetails?.purpose || '',
            fields: assetDetailsResponse?.fieldDetails?.map(field => {
              const spec = assetDetailsResponse.specifications.find(spec => spec.feildId === field.feildId || spec.fieldId === field.feildId) || {};
              return {
                fieldId: field.feildId || '', // Ensure fieldId is properly referenced
                fieldName: field.fieldName || '', // Ensure fieldName is properly referenced
                fieldValId: spec.fieldValId || '',
                fieldData: spec.fieldValue || ' ',
                fieldType: field.fieldType || '',
                options: field.options || [],// Assume options is an array of dropdown options
                mandatory: field.mandatory || ''
              };
            }) || []
          });
          var assetStatus = assetDetailsResponse?.assetDetails?.status
          setIsInstock(assetDetailsResponse?.assetDetails?.status == 'In Stock' || assetDetailsResponse?.assetDetails?.status == 'New/Verified');
          setOptions(getDropdownOptions(assetStatus));
          // Set existing attachments and their active status
          if (assetDetailsResponse?.assetDetails?.attachments) {
            const attachments = assetDetailsResponse.assetDetails.attachments;
            setExistingAttachments(attachments);
            // Initialize active status from existing attachments
            const activeStatusMap = {};
            attachments.forEach((att, idx) => {
              activeStatusMap[idx] = att.active === true;
            });
            setExistingActiveStatus(activeStatusMap);
          }
          console.log('data', formData.fields[0]);
          setActivityData({ ...activityData, event: event, assetNumber: response.data[0].assetDetails.assetNumber });
          setInitiallyAllocated(Number(formData.allocatedPersonId));
        }
      } catch (error) {
        console.error('Error fetching details:', error);
      }
    };
    fetchDetails();
  }, [id]);

  useEffect(() => {
    getAllEmployees()
  }, [])

  const getAllEmployees = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await api.get(`${corporateUrl}/api/all-users-asset`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      console.log("all-users-asset", response.data);
      setAllEmployees(response.data);
      const options = response.data.map(employee => ({
        value: employee.employeeId,
        label: employee.first_name + ' ' + employee.last_name + ' ( ' + employee.employeeId + ' ) ',
      }));
      setOptionsData(options);

    } catch (error) {
      console.error('Error fetching employees', error);
    }
  }

  // Fetch document types
  const fetchDocumentTypes = async () => {
    try {
      const response = await api.get(`${baseUrl}/api/document-types`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      setDocumentTypes(response.data);
    } catch (error) {
      console.error('Error fetching document types:', error);
    }
  };

  useEffect(() => {
    fetchDocumentTypes();
  }, []);

  // Create new document type
  const handleCreateDocumentType = async () => {
    if (!newDocTypeName.trim()) {
      alert('Please enter a document type name');
      return;
    }
    try {
      const response = await api.post(`${baseUrl}/api/document-types`,
        { documentTypeName: newDocTypeName.trim() },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      setDocumentTypes([...documentTypes, response.data]);
      setNewDocTypeName('');
      setShowNewDocTypeInput(false);
      setAttachmentType(response.data.documentTypeName);
    } catch (error) {
      console.error('Error creating document type:', error);
      alert(error.response?.data?.message || 'Error creating document type');
    }
  };

  // Delete document type
  const handleDeleteDocumentType = async (docTypeId, docTypeName) => {
    if (!window.confirm(`Are you sure you want to delete "${docTypeName}"?`)) {
      return;
    }
    try {
      await api.delete(`${baseUrl}/api/document-types/${docTypeId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      setDocumentTypes(documentTypes.filter(dt => dt.documentTypeId !== docTypeId));
      if (attachmentType === docTypeName) {
        setAttachmentType('');
      }
    } catch (error) {
      console.error('Error deleting document type:', error);
      alert(error.response?.data?.message || 'Error deleting document type');
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (docTypeDropdownRef.current && !docTypeDropdownRef.current.contains(event.target)) {
        setIsDocTypeDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    getSelectedEmpData();
  }, [optionsData]);

  const getSelectedEmpData = async () => {
    if (optionsData.length !== null) {
      const selectedData = optionsData.filter(selectData => selectData.value === formData.allocatedPersonId);
      setSelectedOption(selectedData);
    }
  }

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    if (name !== 'allocatedPerson' && value !== null) {
      // Update formData and activityData when a value is selected
      setFormData({
        ...formData,
        [name]: value,
        //allocatedPersonId: Number(value),
      });

      setUpdatedFormData({ ...updatedFormData, [name]: value });

    } else {
      // Handle resetting formData and activityData when value is null or allocatedPerson is changed
      setFormData({
        ...formData,
        [name]: null,
      });

      setUpdatedFormData({ ...updatedFormData, [name]: null });

      // Reset secondary details and assets if needed
      if (name === 'assetType') {
      }
    }
  };

  const handleSelectPersonChange = (data, action) => {
    if (action.name === 'allocatedPerson' && data !== null) {
      const personValue = allEmployees.find(emp => emp.employeeId === data.value);
      setSelectedOption(data)
      setFormData({
        ...formData,
        seat_allocation: personValue.seat_allocation,
        role: personValue.other_role ? personValue.other_role : personValue.role,
        [action.name]: personValue.first_name,
        allocatedPersonId: Number(personValue.employeeId),
        status: data.value ? 'Assigned' : 'In Stock', // Set status to 'Assigned' if an employee is selected, otherwise set to 'In Stock'
      });

      setUpdatedFormData({ ...updatedFormData, [action.name]: personValue.first_name });
    } else {
      setSelectedOption(null)
      setFormData({
        ...formData,
        seat_allocation: null,
        role: null,
        [action.name]: null,
        allocatedPersonId: null,
        status: data === null ? 'In Stock' : 'Assigned',
        role: ''
      });

      setUpdatedFormData({ ...updatedFormData, [action.name]: null });
    }
  };

  const handleFieldChange = (index, e) => {
    const newFields = formData.fields.map((field, idx) => {
      if (index === idx) {
        return { ...field, fieldData: e.target.value };
      }
      return field;
    });
    setFormData({ ...formData, fields: newFields });
    setUpdatedFormData({ ...updatedFormData, fields: newFields });
    calculateUpdatedFields()
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    if (value != "Assigned") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        allocatedPerson: "",
        allocatedPersonId: "",
        seat_allocation: "",
        role: ""
      }))
      selectRef.current?.clearValue();
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    if (details.status === 'Assigned') {
      setUpdatedFormData(prevState => ({
        ...prevState,
        status: value,
        allocatedPersonId: null
      }));
    } else {
      setUpdatedFormData({ ...updatedFormData, status: value });
    }
    console.log('Updated / form', updatedFormData);
  };

  const handleAttachmentFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setAttachmentFile(null);
      return;
    }

    if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
      alert('Only PDF files are allowed');
      e.target.value = null;
      setAttachmentFile(null);
      return;
    }

    setAttachmentFile(file);
  };

  const handleAddAttachment = (e) => {
    e.preventDefault();

    if (!attachmentType || !attachmentName.trim() || !attachmentFile) {
      alert('Please select document type, enter name and choose a PDF file.');
      return;
    }

    const fileUrl = URL.createObjectURL(attachmentFile);

    const newAttachment = {
      type: attachmentType,
      name: attachmentName.trim(),
      fileName: attachmentFile.name,
      file: attachmentFile,
      url: fileUrl,
    };

    setFormData((prev) => ({
      ...prev,
      attachments: [...(prev.attachments || []), newAttachment],
    }));

    setUpdatedFormData((prev) => ({
      ...prev,
      attachments: [...((prev && prev.attachments) || []), newAttachment],
    }));

    setAttachmentType('');
    setAttachmentName('');
    setAttachmentFile(null);

    const fileInput = document.getElementById('attachmentFile');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const groupFields = (arr, groupSize) => {
    const group = [];
    for (let i = 0; i < arr.length; i += groupSize) {
      group.push(arr.slice(i, i + groupSize));
    }
    return group;
  };

  const calculateUpdatedFields = () => {
    let updatedFields = [];

    for (let key in updatedFormData) {
      if (updatedFormData.hasOwnProperty(key) && key !== 'fields') {
        // Skip attachments as they are handled separately below
        if (key === 'attachments') {
          continue;
        }

        let prevValue = details[key] !== undefined ? details[key] : '';
        let currentValue = updatedFormData[key] !== null ? updatedFormData[key] : '';

        // If either value is an object/array, don't try to store it in activity.updatedFields
        if (typeof prevValue === 'object' || typeof currentValue === 'object') {
          continue;
        }

        if (prevValue !== currentValue) {
          updatedFields.push({
            key: key,
            prev_Value: prevValue,
            current_value: currentValue
          });
        }
      }
    }
    //Check for nested fields
    if (updatedFormData.fields) {
      updatedFormData.fields.forEach((updatedField, index) => {
        let prevField = details.fields ? details.fields[index] : {};
        if (prevField && updatedField.fieldData !== prevField.fieldData && updatedField.fieldType !== 'dropdown') {
          updatedFields.push({
            key: updatedField.fieldName,
            prev_Value: prevField.fieldData !== undefined ? prevField.fieldData : '',
            current_value: updatedField.fieldData !== null ? updatedField.fieldData : ''
          });
        } else if (prevField && updatedField.fieldData !== prevField.fieldData && updatedField.fieldType === 'dropdown') {
          const prevOption = updatedField.options.find(op => Number(op.value) === Number(prevField.fieldData)) || {};
          const currentOption = updatedField.options.find(op => Number(op.value) === Number(updatedField.fieldData)) || {};
          updatedFields.push({
            key: updatedField.fieldName,
            prev_Value: prevField.fieldData !== undefined ? prevOption.label : '',
            current_value: updatedField.fieldData !== null ? currentOption.label : ''
          });
        }
      });
    }

    // 1. Check for newly added attachments
    if (formData.attachments) {
      formData.attachments.forEach((att, index) => {
        if (!deletedNewIndices.includes(index)) {
          updatedFields.push({
            key: `Attachment: ${att.name}`,
            prev_Value: '',
            current_value: 'Added'
          });
        }
      });
    }

    // 2. Check for deleted existing attachments
    if (existingAttachments) {
      existingAttachments.forEach((att, index) => {
        if (deletedExistingIndices.includes(index)) {
          updatedFields.push({
            key: `Attachment: ${att.name}`,
            prev_Value: 'Existing',
            current_value: 'Removed'
          });
        } else {
          // 3. Check for status changes in remaining existing attachments
          const initialStatus = att.active === true ? 'Active' : 'Inactive';
          const currentStatus = existingActiveStatus[index] === true ? 'Active' : 'Inactive';
          if (initialStatus !== currentStatus) {
            updatedFields.push({
              key: `Attachment: ${att.name} Status`,
              prev_Value: initialStatus,
              current_value: currentStatus
            });
          }
        }
      });
    }

    return updatedFields;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    // Validation: Check specific fields
    const fieldLabels = {
      'assetNumber': 'Asset Number',
      'assetType': 'Asset Type',
      'assetCategory': 'Category',
      'yearOfPurchase': 'Purchased Year',
      'purpose': 'Purpose'
    };

    const requiredFields = [
      'assetNumber',
      'assetType',
      'assetCategory',
      'yearOfPurchase'
    ];

    const emptyFields = requiredFields.filter(field => !formData[field] || (typeof formData[field] === 'string' && !formData[field].trim()));

    // Purpose is mandatory for PC/Desktop
    if (formData.assetType === 'PC/Desktop' && (!formData.purpose || !formData.purpose.trim())) {
      emptyFields.push('purpose');
    }

    if (emptyFields.length > 0) {
      const missingLabels = emptyFields.map(field => fieldLabels[field] || field).join(', ');
      setPopup({
        type: 'error',
        message: `${missingLabels} ${emptyFields.length === 1 ? 'field' : 'fields'} must be filled out`
      });
      return;
    }

    const updatedFields = calculateUpdatedFields();
    console.log('Updated Fields:', updatedFields);
    const activityDetails = {}
    if (updatedFields) {
      activityDetails.assetNumber = activityData.assetNumber;
      activityDetails.employeeId = activityData.employeeId;
      activityDetails.event = activityData.event;
      activityDetails.updatedFields = updatedFields;
    }
    if (initialAllocated !== formData.employeeId) {
      formData.parentAsset = '';
    }
    console.log('activi', activityDetails);
    try {
      if (!token) {
        navigate("/login")
      } else {
        const formDataToSend = new FormData();

        // Append simple scalar fields
        formDataToSend.append('assetNumId', formData.assetNumId || '');
        formDataToSend.append('assetNumber', formData.assetNumber || '');
        formDataToSend.append('employeeId', formData.employeeId != null ? formData.employeeId : '');
        formDataToSend.append('assetType', formData.assetType || '');
        formDataToSend.append('assetTypeId', formData.assetTypeId || '');
        formDataToSend.append('assetCategory', formData.assetCategory || '');
        formDataToSend.append('status', formData.status || '');
        formDataToSend.append('allocatedPerson', formData.allocatedPerson || '');
        formDataToSend.append('allocatedPersonId', formData.allocatedPersonId != null ? formData.allocatedPersonId : '');
        formDataToSend.append('seat_allocation', formData.seat_allocation || '');
        formDataToSend.append('role', formData.role || '');
        formDataToSend.append('yearOfPurchase', formData.yearOfPurchase || '');
        formDataToSend.append('remarks', formData.remarks || '');
        formDataToSend.append('parentAsset', formData.parentAsset || '');
        formDataToSend.append('purpose', formData.purpose || '');

        // Append dynamic fields as JSON
        formDataToSend.append('fields', JSON.stringify(formData.fields || []));

        // Combine existing attachments with new attachments (excluding deleted ones)
        // Existing attachments (already uploaded to S3) - filter out deleted ones
        const existingAttachmentsMeta = (existingAttachments || [])
          .filter((_, idx) => !deletedExistingIndices.includes(idx))
          .map((att, idx) => {
            // Find the original index before filtering
            const originalIdx = existingAttachments.findIndex(a => a === att);
            return {
              type: att.type,
              name: att.name,
              fileName: att.fileName,
              s3Url: att.s3Url,
              uploadDate: att.uploadDate,
              active: existingActiveStatus[originalIdx] === true,
            };
          });

        // New attachments metadata (exclude File and url) - filter out deleted ones
        const filteredNewAttachments = (formData.attachments || [])
          .filter((_, idx) => !deletedNewIndices.includes(idx));

        const newAttachmentsMeta = filteredNewAttachments.map((att, idx) => {
          // Find the original index before filtering
          const originalIdx = formData.attachments.findIndex(a => a === att);
          return {
            type: att.type,
            name: att.name,
            fileName: att.fileName,
            active: newActiveStatus[originalIdx] === true,
          };
        });

        // Combine both existing and new attachments
        const allAttachmentsMeta = [...existingAttachmentsMeta, ...newAttachmentsMeta];
        formDataToSend.append('attachments', JSON.stringify(allAttachmentsMeta));

        // Append only new attachment files (excluding deleted ones) so backend can upload them to S3
        filteredNewAttachments.forEach(att => {
          if (att.file) {
            formDataToSend.append('attachmentFiles', att.file);
          }
        });

        const res = await api.put(`${baseUrl}/api/asset-update/${objId}`, formDataToSend, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
        if (updatedFields.length !== 0) {
          await api.post(`${baseUrl}/api/add-activity`, activityDetails, {
            headers: {
              'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
            },
          });
        }
        setActiveIndex(3);
        navigate(`/all-assets`);
      }
    } catch (error) {
      console.error('Error registering device:', error);
      if (error.response && error.response.data) {
        setPopup({ type: 'error', message: error.response.data });
      } else {
        setPopup({ type: 'error', message: 'Registration not completed due to some technical issues' });
      }
    }
  };

  const handleLoginClick = () => {
    navigate("/login")
  }

  const closePopup = () => {
    setPopup(null);
  };

  const getDropdownOptions = (status) => {
    switch (status) {
      case 'New/Verified':
        return ['New/Verified', 'In Stock', 'Assigned', 'Lost/Stolen',]
      case 'In Stock':
        return ['In Stock', 'Assigned', 'To Be Decommissioned', 'Maintenance', 'Lost/Stolen',];
      case 'Assigned':
        return ['Assigned', 'Maintenance', 'Returned', 'Lost/Stolen',];
      case 'Returned':
        return ['Returned', 'Clearance Done', 'Maintenance', 'In Stock', 'Lost/Stolen',];
      case 'Clearance Done':
        return ['Clearance Done', 'Maintenance', 'Lost/Stolen',];
      case 'Maintenance':
        return ['Maintenance', 'In Stock', 'Lost/Stolen',];
      case 'To Be Decommissioned':
        return ['To Be Decommissioned', 'Obsolete', 'Lost/Stolen',];
      case 'Obsolete':
        return ["Obsolete"]
      default:
        return [];
    }
  };
  // useEffect(() =>{
  //   setOptions(getDropdownOptions(assetStatus));
  //   console.log("status",assetDetailsResponse?.assetDetails?.status)
  // },[assetStatus])

  return (
    <div className='content-section col-12 col-md-12 col-xl-11 asset-main'>
      <div className='w-100'>
        <div data-tooltip-id="tool-tip-back-button" data-tooltip-content="Back" className='backBtn' onClick={() => navigate(-1)}><HiOutlineArrowSmLeft className='nxt-prev-icon' /></div>
        <Tooltip id="tool-tip-back-button" className="asset-tooltip" border="1px solid #5c2680" place="right" />
      </div>
      <div className='container'>
        <div className="assethead-head" >
          <div className="activitylog-heading">
            <h3>Update Asset</h3>
          </div>
        </div>
        <form className="asset-form" onSubmit={handleSubmit}>
          <div className='form-section'>
            <div className='refresh-container'>
              <div className='refresh-item'>
                Reset <IoMdRefresh onClick={() => window.location.reload()} />
              </div>
            </div>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faCheckCircle} />
              <span className='form-section-label'>Asset </span>
            </div>
            <div className="form-row asset-first-details-section">
              <div className="form-group">
                <label htmlFor="assetType" className='mr-2'  >Asset Type: <span className="bg-red">*</span></label>
                <input type="text" id="assetType" name="assetType" value={formData.assetType} readOnly />
              </div>

              <div className="form-group">
                <label htmlFor="assetCategory" className='mr-2'>Category: <span className="bg-red">*</span></label>
                <input id="assetCategory" name="assetCategory" value={formData.assetCategory} readOnly />
              </div>

              <div className="form-group assetyearpicker">
                <label htmlFor="yearOfPurchase">Purchased Year: <span className="bg-red">*</span></label>
                <input type="text" id="yearOfPurchase" className="date-own form-control" name="yearOfPurchase" value={formData.yearOfPurchase} readOnly />
              </div>

              <div className="form-group">
                <label htmlFor="assetNumber">Asset Number: <span className="bg-red">*</span></label>
                <input type="text" id="assetNumber" className='read-only' name="assetNumber" value={formData.assetNumber} readOnly />
              </div>

              {formData.assetType === 'PC/Desktop' && (
                <div className="form-group">
                  <label htmlFor="purpose">Purpose:<span className="bg-red">*</span></label>
                  <select id="purpose" name="purpose" value={formData.purpose} onChange={handleChange} required>
                    <option value="">Select Purpose</option>
                    <option value="System">System</option>
                    <option value="Server">Server</option>
                  </select>
                  {submitted && (!formData.purpose || !formData.purpose.trim()) && (
                    <span className="error-message">Please select a purpose</span>
                  )}
                </div>
              )}

              <div className="form-group readonly-group">
                <label htmlFor="status" className='mr-2'>Status:</label>
                <select
                  id="status"
                  className="status-selection"
                  name="status"
                  value={formData.status}
                  onChange={handleSelectChange}
                >
                  {options && options?.map((option) => (
                    <option key={option} value={option} disabled={option === "Assigned"}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className='form-section'>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faUserCheck} />
              <span className='form-section-label'>Allocated Details</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="allocatedPerson" className='mr-2'>Allocated Person:</label>
                {
                  optionsData ?
                    <>
                      <Select
                        isClearable={true}
                        id="allocatedPerson"
                        closeMenuOnSelect={true}
                        name="allocatedPerson"
                        value={selectedOption}
                        defaultValue={selectedOption}
                        onChange={handleSelectPersonChange}
                        options={optionsData}
                        isDisabled={!instock}
                        ref={selectRef}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: '#e7daef',
                            primary: '#5c2680',
                          },
                        })} />
                    </>

                    :
                    <>No data</>
                }
              </div>

              <div className="form-group">
                <label htmlFor="role">Role:</label>
                <input type="text" id="role" name="role" value={selectedOption ? formData.role : ''} readOnly />
              </div>

              <div className="form-group">
                <label htmlFor="">Seat Allocation:</label>
                <input type="text" id="seat_allocation" name="seat_allocation" value={selectedOption ? formData.seat_allocation : ''} readOnly />
              </div>
            </div>
          </div>

          <div className='form-section'>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faCircleInfo} />
              <span className='form-section-label'>Asset Specifications </span>
            </div>
            <div className="form-row main-grid-sec">
              {formData.fields && formData.fields.length > 0 ? groupFields(formData.fields, 3).map((fieldRow, rowIndex) => (
                <div key={rowIndex} className="row inside-section">
                  {fieldRow.map((field, index) => (
                    <div key={field.fieldId} className="form-group">
                      <label>
                        {field.fieldName.charAt(0).toUpperCase() + field.fieldName.slice(1)}
                        <span className="bg-red">{field.mandatory === true ? ' *' : ''}</span>
                      </label>
                      {field.fieldType === 'text' && (
                        <input
                          type="text"
                          value={(formData.fields[rowIndex * 3 + index] && formData.fields[rowIndex * 3 + index].fieldData) || ''}
                          onChange={(e) => handleFieldChange(rowIndex * 3 + index, e)}
                          required={field.mandatory}
                        />
                      )}
                      {field.fieldType === 'date' && (
                        <input
                          type="date"
                          value={(formData.fields[rowIndex * 3 + index] && formData.fields[rowIndex * 3 + index].fieldData) || ''}
                          onChange={(e) => handleFieldChange(rowIndex * 3 + index, e)}
                          required={field.mandatory}
                        />
                      )}
                      {field.fieldType === 'dropdown' && (
                        <select
                          value={(formData.fields[rowIndex * 3 + index] && formData.fields[rowIndex * 3 + index].fieldData) || ''}
                          onChange={(e) => handleFieldChange(rowIndex * 3 + index, e)}
                          required={field.mandatory}
                        >
                          <option value="" name="">Select an option</option>
                          {field.options.map(option => (
                            <option key={option.key} value={option.value} name={option.label}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  ))}
                </div>
              )) : <div className="row inside-section"><p>No fields available</p></div>}
            </div>
          </div>

          {/* Attachments section */}
          <div className='form-section'>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faCircleInfo} />
              <span className='form-section-label'>Attachments</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="attachmentType">Document Type</label>
                {!showNewDocTypeInput ? (
                  <div ref={docTypeDropdownRef} style={{ position: 'relative' }}>
                    <div
                      onClick={() => setIsDocTypeDropdownOpen(!isDocTypeDropdownOpen)}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        minHeight: '38px',
                      }}
                    >
                      <span style={{ color: attachmentType ? '#333' : '#999' }}>
                        {attachmentType || 'Select document type'}
                      </span>
                      <span style={{ fontSize: '10px', color: '#666' }}>▼</span>
                    </div>
                    {isDocTypeDropdownOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: '#fff',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          zIndex: 1000,
                          maxHeight: '200px',
                          overflowY: 'auto',
                        }}
                      >
                        {documentTypes.map((docType) => (
                          <div
                            key={docType.documentTypeId}
                            onClick={() => {
                              setAttachmentType(docType.documentTypeName);
                              setIsDocTypeDropdownOpen(false);
                            }}
                            style={{
                              padding: '8px 12px',
                              cursor: 'pointer',
                              backgroundColor: attachmentType === docType.documentTypeName ? '#f0e6f5' : 'transparent',
                              borderBottom: '1px solid #eee',
                            }}
                            onMouseEnter={(e) => {
                              if (attachmentType !== docType.documentTypeName) {
                                e.currentTarget.style.backgroundColor = '#f9f9f9';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (attachmentType !== docType.documentTypeName) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                              }
                            }}
                          >
                            {docType.documentTypeName}
                          </div>
                        ))}
                        <div
                          onClick={() => {
                            setShowNewDocTypeInput(true);
                            setIsDocTypeDropdownOpen(false);
                          }}
                          style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            color: '#5c2680',
                            fontWeight: 500,
                            borderTop: documentTypes.length > 0 ? '1px solid #ddd' : 'none',
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f9f9f9'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          + Add New Type...
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="text"
                      value={newDocTypeName}
                      onChange={(e) => setNewDocTypeName(e.target.value)}
                      placeholder="Enter new document type"
                      style={{ flex: 1 }}
                      autoFocus
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleCreateDocumentType();
                        }
                      }}
                    />
                    <button
                      type="button"
                      onClick={handleCreateDocumentType}
                      style={{
                        padding: '6px 12px',
                        backgroundColor: '#5c2680',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Add
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setShowNewDocTypeInput(false);
                        setNewDocTypeName('');
                      }}
                      style={{
                        padding: '6px 12px',
                        backgroundColor: '#fff',
                        color: '#666',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="attachmentName">Document Name</label>
                <input
                  id="attachmentName"
                  name="attachmentName"
                  type="text"
                  value={attachmentName}
                  onChange={(e) => setAttachmentName(e.target.value)}
                  placeholder="Enter document name"
                  disabled={!attachmentType}
                />
              </div>

              <div className="form-group">
                <label htmlFor="attachmentFile">Upload PDF</label>
                <input
                  id="attachmentFile"
                  name="attachmentFile"
                  type="file"
                  accept=".pdf"
                  onChange={handleAttachmentFileChange}
                  disabled={!attachmentName || !attachmentName.trim()}
                />
                <span style={{ fontSize: '12px', display: 'block', marginTop: '4px' }}>
                  Only PDF files are allowed.
                </span>
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                <button
                  type="button"
                  className='button'
                  onClick={handleAddAttachment}
                  style={{ width: 'auto', padding: '6px 16px', backgroundColor: '#fff', color: '#5c2680', border: '1px solid #5c2680', borderRadius: '5px' }}
                >
                  + Attach
                </button>
              </div>
            </div>

            {(() => {
              // Combine existing and new attachments with metadata
              const allAttachments = [
                // Existing attachments
                ...(existingAttachments || []).map((att, idx) => ({
                  ...att,
                  originalIndex: idx,
                  isExisting: true,
                  isDeleted: deletedExistingIndices.includes(idx),
                  isActive: existingActiveStatus[idx] === true,
                  sortDate: att.uploadDate ? new Date(att.uploadDate) : new Date(0),
                })),
                // New attachments
                ...(formData.attachments || []).map((att, idx) => ({
                  ...att,
                  originalIndex: idx,
                  isExisting: false,
                  isDeleted: deletedNewIndices.includes(idx),
                  isActive: newActiveStatus[idx] === true,
                  sortDate: new Date(), // New attachments are considered as just added
                })),
              ]
                .filter(att => !att.isDeleted) // Filter out deleted
                .sort((a, b) => b.sortDate - a.sortDate); // Sort by date, newest first

              if (allAttachments.length === 0) return null;

              return (
                <div className="form-row" style={{ marginTop: '10px' }}>
                  <div className="form-group" style={{ width: '100%' }}>
                    <label>Added Attachments:</label>
                    <div
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                      }}
                    >
                      {allAttachments.map((att, displayIdx) => {
                        const uploadDateLabel = att.uploadDate
                          ? new Date(att.uploadDate).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                          })
                          : att.isExisting ? '' : 'Just now';

                        return (
                          <div
                            key={`${att.isExisting ? 'existing' : 'new'}-${att.originalIndex}`}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '8px 4px',
                              borderBottom: displayIdx !== allAttachments.length - 1 ? '1px solid #e4e4e4' : 'none',
                            }}
                          >
                            {/* Left side: Column 1 & 2 grouped together */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                              {/* Column 1: Title and Type - Fixed width */}
                              <div style={{ width: '200px', minWidth: '200px' }}>
                                {/* Row 1: Document Name */}
                                <div style={{
                                  fontSize: '13px',
                                  fontWeight: 500,
                                  color: '#333',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}>
                                  <a
                                    href={att.isExisting ? att.s3Url : att.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: '#5c2680', textDecoration: 'underline' }}
                                  >
                                    {att.name || 'Untitled Document'}
                                  </a>
                                </div>
                                {/* Row 2: Type (filename) */}
                                <div style={{
                                  fontSize: '12px',
                                  color: '#666',
                                  marginTop: '2px',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}>
                                  {att.type || 'PDF'} <span style={{ color: '#999' }}>({att.fileName || 'PDF'})</span>
                                </div>
                              </div>

                              {/* Column 2: Date */}
                              <div style={{
                                fontSize: '12px',
                                color: '#888',
                                whiteSpace: 'nowrap',
                              }}>
                                {uploadDateLabel}
                              </div>
                            </div>

                            {/* Column 3: Actions - stays at end */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              {/* Active Toggle */}
                              <button
                                type="button"
                                onClick={() => {
                                  if (att.isExisting) {
                                    setExistingActiveStatus({
                                      ...existingActiveStatus,
                                      [att.originalIndex]: !att.isActive
                                    });
                                  } else {
                                    setNewActiveStatus({
                                      ...newActiveStatus,
                                      [att.originalIndex]: !att.isActive
                                    });
                                  }
                                }}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  cursor: 'pointer',
                                  padding: '4px 6px',
                                  borderRadius: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'background-color 0.15s ease',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#ecfdf3';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                }}
                                title={att.isActive ? "Mark as inactive" : "Mark as active"}
                              >
                                {att.isActive ? (
                                  <BsCheckCircleFill style={{ color: '#22c55e', fontSize: '16px' }} />
                                ) : (
                                  <BsCircle style={{ color: '#aaa', fontSize: '16px' }} />
                                )}
                              </button>
                              {/* Delete Button */}
                              <button
                                type="button"
                                onClick={() => {
                                  if (att.isExisting) {
                                    setDeletedExistingIndices([...deletedExistingIndices, att.originalIndex]);
                                  } else {
                                    setDeletedNewIndices([...deletedNewIndices, att.originalIndex]);
                                  }
                                }}
                                style={{
                                  background: 'none',
                                  border: 'none',
                                  cursor: 'pointer',
                                  padding: '4px 6px',
                                  borderRadius: '4px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'background-color 0.15s ease',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#fee8e7';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                }}
                                title="Remove attachment"
                              >
                                <BsTrash style={{ color: '#c8372d', fontSize: '14px' }} />
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>

          <div className='form-section'>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="remarks">Remarks:</label>
                <textarea type="text" id="remarks" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>
            </div>
          </div>

          <button className='button asset-submit-btn' type="submit">Update</button>
        </form>

        {popup && <Popup type={popup.type} message={popup.message} onClose={closePopup} />}
      </div>

    </div>

  );
};

export default Update;
